import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function initGsapHero() {
    if (!document.querySelector(".home-hero")) return;

    // Remove setTimeout and handle initialization immediately
    const site_logo = document.querySelector(
        ".elementor-widget-theme-site-logo img"
    );
    const site_logo_width = site_logo.width;
    const hero_logo = document.querySelector(".home-hero__logo");
    const section = document.querySelector(".home-hero");
    const section_image = document.querySelector(".home-hero__image");
    const section_content = document.querySelector(".home-hero__content");
    const section_content2 = document.querySelector(".home-hero__content2");

    // Set initial states immediately
    gsap.set(section, {
        clearProps: "all",
        position: "relative",
    });

    gsap.set(section_content2, {
        opacity: 0,
        width: "100%",
        pointerEvents: "none",
        // position: "absolute",
    });

    gsap.set(site_logo, {
        opacity: 0,
    });

    // Create ScrollTrigger
    ScrollTrigger.create({
        trigger: section,
        start: "clamp(top top)",
        end: "+=200%",
        // markers: true,
        pin: true,
        pinSpacing: true,
        scrub: true,
        animation: gsap
            .timeline()
            .to(
                section_content,
                {
                    opacity: 0,
                    duration: 1,
                },
                "start"
            )
            .to(
                section_content,
                {
                    scale: 0.8,
                    filter: "blur(100px)",
                    duration: 1,
                },
                "start+=0.3"
            )
            .to(
                hero_logo,
                {
                    width: site_logo_width,
                    opacity: 0,
                    duration: 1,
                },
                "start+=0.3"
            )
            .to(
                site_logo,
                {
                    opacity: 1,
                    duration: 1,
                },
                "start+=1.5"
            )
            .to(
                section_image,
                {
                    scale: 25,
                    transformOrigin: "center center",
                    duration: 2,
                },
                "start"
            )
            .to(
                section_image,
                {
                    opacity: 0,
                    filter: "blur(10px)",
                    duration: 1.5,
                },
                "start+=0.5"
            )
            .to(
                section_content2,
                {
                    opacity: 1,
                    duration: 1,
                    pointerEvents: "all",
                },
                "start+=1.25"
            ),
    });
}
